export interface Possible<T> {
  default: T;
  possible: T[];
}

export type BidAsk<T> = {
  bid: T;
  ask: T;
};

export type BidAskPair = BidAsk<number>;

export type QuoteType = 'Tradeable' | 'Indicative' | 'Withdraw';

export type QuotePredealCheck = QuotePredealCheckStatusIcon | QuotePredealCheckStatusLabel;

export interface QuotePredealCheckStatusIcon {
  Type: 'Icon';
  Label: string;
  StatusHealth: PredealCheckStatusHealth;
}

export interface QuotePredealCheckStatusLabel {
  Type: 'Label';
  StatusHealth: 'Unknown';
  Label: string;
  StatusValue: string | null;
}

export type PredealCheck = PredealCheckStatusIcon | PredealCheckStatusLabel;

export interface PredealCheckStatusIcon {
  type: 'Icon';
  label: string;
  statusHealth: PredealCheckStatusHealth;
}

export type PredealCheckStatusHealth = 'Unknown' | 'Ok' | 'Nok' | 'Warning' | 'Missing';

export interface PredealCheckStatusLabel {
  type: 'Label';
  statusHealth: 'Unknown';
  label: string;
  statusValue: string;
}

export type Way = 'Bid' | 'Ask';

export const allPriceTypes = ['AMOUNT', 'VOLATILITY', 'PERCENT', 'PPS'] as const;
export type PriceType = (typeof allPriceTypes)[number];

export type CurrencyChoice = typeof FIRST_CURRENCY | typeof SECOND_CURRENCY;
export const FIRST_CURRENCY = 1;
export const SECOND_CURRENCY = 2;

export const targetLegProductTypes = [
  'ProductTypeUnknown',
  'TargetAccumulator',
  'TargetEkiAccumulator',
  'PivotTargetEkiAccumulator',
  'PivotTargetAccumulator',
] as const;
export type TargetLegProductType = (typeof targetLegProductTypes)[number];

export type OmsErrors = {
  [field: string]: OmsFieldError;
};

export type OmsFieldError = {
  errorCode: number;
  errorDescription: string;
  field: string;
};

export type OmsWarning = {
  [field: string]: OmsFieldWarning;
};

export type OmsFieldWarning = {
  warningCode: number;
  warningDescription: string;
  field: string;
};
export type Frequency =
  | 'Daily'
  | 'EndOfMonth'
  | 'EndOfMonthValue'
  | 'EveryDay'
  | 'Maturity'
  | 'Monthly'
  | 'None'
  | 'Quarterly'
  | 'SemiAnnually'
  | 'TwoWeeks'
  | 'Weekly'
  | 'Yearly';
